module.exports = __webpack_public_path__ + "img/logo1 (42).b72c17e4.jpg";